class TransportConstants {
  static readonly HEADER_CONTENT_TYPE: string = 'content-type';
  static readonly CONTENT_TYPE_PROTO: string = 'application/x-protobuf';
}

export { TransportConstants };
